import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { EVENTS_PER_PAGE_HOME } from 'constants/events.constant';
import { useInfiniteEvents } from 'queries/events/useInfiniteEvents';
import { useOriginClick } from 'services/datalayer/browse';

import EventCard from 'components/@events/EventCard';

const HomeEvents = () => {
  const handleClick = useOriginClick('All events', 'Discover');
  const { events, fetchNextPage, hasNextPage, isFetching } = useInfiniteEvents({
    eventsPerPage: EVENTS_PER_PAGE_HOME,
  });

  if (!events?.length) {
    return null;
  }

  return (
    <Stack
      sx={{
        mb: { xs: 8, md: 15 },
      }}
    >
      <Container>
        <Typography
          variant="h4"
          component="h2"
          sx={{
            mb: 2,
          }}
        >
          <FormattedMessage id="home.events" />
        </Typography>
      </Container>
      <Stack
        sx={{
          px: 2,
          gap: 2,
          display: { xs: 'flex', md: 'none' },
        }}
      >
        {events.map((event) => (
          <EventCard key={event.id} event={event} />
        ))}
      </Stack>
      <Box sx={{ display: { xs: 'none', md: 'block' } }}>
        <Container>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr 1fr',
              gap: 2,
            }}
          >
            {events.map((event) => (
              <EventCard key={event.id} event={event} onClick={handleClick} />
            ))}
          </Box>
        </Container>
      </Box>
      <Container>
        <Box
          sx={{
            textAlign: 'center',
            mt: { xs: 2, md: 3 },
          }}
        >
          {hasNextPage && (
            <Button
              onClick={() => {
                fetchNextPage();
              }}
              loading={isFetching}
              variant="outlined"
              color="secondary"
              sx={{ width: { xs: '100%', md: 'initial' } }}
            >
              <FormattedMessage id="events_overview.events.load_more" />
            </Button>
          )}
        </Box>
      </Container>
    </Stack>
  );
};

export default HomeEvents;
